import React from "react";

// Video banner feature disabled — return nothing.
const ShopVideoBanners = () => {
  return null;
};

export default ShopVideoBanners;
